import { useSchedulingAssignment } from "../hooks/useSchedulingAssignment.js";
import "react";
import { Skeleton } from "@therms/atalaya";
import { jsx } from "react/jsx-runtime";
//#region src/modules/Scheduling/shared/SchedulingAssignmentTitle.tsx
function SchedulingAssignmentTitle({ id }) {
	const { data, loading } = useSchedulingAssignment(id);
	if (!data?.title && loading) return /* @__PURE__ */ jsx(Skeleton.Text, {
		chars: 20,
		inline: true
	});
	if (!data) return null;
	return /* @__PURE__ */ jsx("span", { children: data.title });
}
//#endregion
export { SchedulingAssignmentTitle };

//# sourceMappingURL=SchedulingAssignmentTitle.js.map